import envConfig from "@/config/envConfig";
import socketIO from "socket.io-client";

const BASE_URL = envConfig.API_URL_BASED;
// "https://cms.ivis.com.my";
// "http://localhost:3013";
//   process.env.REACT_APP_API_URL;

export const socket = socketIO.connect(BASE_URL);
